// extracted by mini-css-extract-plugin
export var chevron = "jTtPJZsEP9P710HUgCwt";
export var close = "HCEnmeNdQ6SuCheJXqLv";
export var content = "cJ3Byu05w9qXEYxObig_";
export var message = "Xe0GULet1C1aZFyw6TYT";
export var open = "FePU2L41vtmSZMGnL2yd";
export var root = "bKm_9kftikD3ek5dweiA";
export var trigger = "wAF6Upp92fJAKH4by0yk";